import { Accordion, AccordionBody, AccordionHeader, AccordionItem } from "reactstrap";
import './process-step-item-card.css';
import { ModelViewer } from "./model-viewer/model-viewer";
import { useState } from "react";
import { ToolChooserModal } from "./tool-chooser-modal/tool-chooser-modal";
import { Button, Switch } from "antd";
import { CheckOutlined, CloseOutlined, EyeInvisibleOutlined, EyeOutlined, QuestionCircleTwoTone } from "@ant-design/icons";
import * as THREE from 'three';
import { getImageUrl } from "../../../../../../utils/image-helper/get-image-url";
import { Project } from "../../../../types/api/project/get-project-success-response";
import { Tool } from "../../../../types/api/tool/get-tools-success-response";
import { NewProcessStepItemWithEndpointModelAndDoneAndStartingModelNameAndReferenceModelName, ProcessStepItemWithEndpointModelAndDoneAndStartingModelNameAndReferenceModelName } from "../../../../types/api/process-step-item/process-step-item";

type ProcessStepItemCardProps = {
    project: Project;
    processStepItem: ProcessStepItemWithEndpointModelAndDoneAndStartingModelNameAndReferenceModelName | NewProcessStepItemWithEndpointModelAndDoneAndStartingModelNameAndReferenceModelName;
    selectedModelUUID: string | null;
    index: number;
    isOpen: boolean;
    onOpenAccordion: () => void;
    onCloseAccordion: () => void;
    onToolChoose?: (tool: Tool) => void;
    onProcessStepItemDelete?: () => void;
    onStartingModelClick?: () => void;
    onSettingStartingModelVisible?: (visible: boolean) => void;
    onSettingModelToBeMovedConnectedToReferenceModel?: (connected: boolean) => void;
    onReferenceModelClick?: () => void;
    onToolDeleteClick?: () => void;
    onEndpointModelClick?: () => void;
    onEndpointModelDeleteClick?: () => void;
    onDoneClick?: () => void;
};

export const ProcessStepItemCard = ({
        processStepItem,
        index,
        isOpen,
        onOpenAccordion,
        onCloseAccordion,
        project,
        onToolChoose,
        onProcessStepItemDelete,
        selectedModelUUID,
        onStartingModelClick,
        onSettingStartingModelVisible,
        onSettingModelToBeMovedConnectedToReferenceModel,
        onReferenceModelClick,
        onToolDeleteClick,
        onEndpointModelClick,
        onEndpointModelDeleteClick,
        onDoneClick
    }: ProcessStepItemCardProps) => {
    const [isToolChooserModalOpen, setIsToolChooserModalOpen] = useState(false);
    
    let doneButtonDisabled = false;
    if (
        processStepItem.done ||
        !processStepItem.modelToBeMovedUUID
    ) doneButtonDisabled = true;

    const handleToolChoose = (tool: Tool) => {
        if (onToolChoose) {
            onToolChoose(tool);
            setIsToolChooserModalOpen(false);
        }
    };

    const handleDoneButtonClick = () => {
        if (onDoneClick) onDoneClick();
    };

    return (
        <>
            <Accordion
                open={isOpen ? '1' : ''}
                toggle={
                    () => {
                        if (isOpen) onCloseAccordion();
                        else onOpenAccordion();
                    }
                }
                className="process-step-item-card-accordion"
            >
                <AccordionItem>
                    <AccordionHeader targetId={'1'} className="process-step-item-card-accordion-header">
                        { index + 1 }. elem
                        &nbsp;
                        <img
                            src={getImageUrl('delete-icon.png')}
                            alt="del"
                            onClick={
                                (e) => {
                                    e.stopPropagation();
                                    if (onProcessStepItemDelete) onProcessStepItemDelete();
                                }
                            }
                            title="Törlés"
                        />
                    </AccordionHeader>
                    <AccordionBody accordionId={'1'}>
                        <div className='mb-1'>
                            <span
                                className={`text-decoration-underline cursor-pointer ${ processStepItem.modelToBeMovedUUID && processStepItem.modelToBeMovedUUID === selectedModelUUID && 'fw-bold' }`}
                                onClick={
                                    (e) => {
                                        e.stopPropagation();
                                        
                                        if (onStartingModelClick) onStartingModelClick();
                                    }
                                }
                            >
                                *Elem kiválasztása
                            </span>
                            &nbsp;
                            {
                                processStepItem.isModelToBeMovedVisible ? (
                                    <EyeInvisibleOutlined
                                        className="eye-icon"
                                        onClick={
                                            () => {
                                                if (onSettingStartingModelVisible) {
                                                    onSettingStartingModelVisible(false);
                                                }
                                            }
                                        }
                                        title="Elem elrejtése"
                                    />
                                ) : (
                                    <EyeOutlined
                                        className="eye-icon"
                                        onClick={
                                            () => {
                                                if (onSettingStartingModelVisible) {
                                                    onSettingStartingModelVisible(true);
                                                }
                                            }
                                        }
                                        title="Elem megjelenítése"
                                    />
                                )
                            }
                            <br />
                            {
                                processStepItem.modelToBeMovedUUID ? (
                                    <>
                                        {
                                            processStepItem.startingModelName && (
                                                <>
                                                    <img src={getImageUrl('check-icon.png')} alt='check-icon' style={{ width: '20px' }} />
                                                    &nbsp;
                                                    <span className='red-color fw-bold'>{ processStepItem.startingModelName }</span>
                                                </>
                                            )
                                        }
                                    </>
                                ) : (
                                    <span className='red-color question-mark fw-bold'>?</span>
                                )
                            }
                        </div>
                        <div className='mb-1'>
                            <span
                                className={`text-decoration-underline cursor-pointer ${ processStepItem.referenceModelUUID && processStepItem.referenceModelUUID === selectedModelUUID && 'fw-bold' }`}
                                onClick={
                                    (e) => {
                                        e.stopPropagation();
                                        if (onReferenceModelClick) onReferenceModelClick();
                                    }
                                }
                            >
                                Referenciapont
                            </span>
                            {
                                processStepItem.referenceModelUUID && (
                                    <>
                                        &nbsp;
                                        <Switch
                                            size="small"
                                            onChange={
                                                (checked) => {
                                                    if (onSettingModelToBeMovedConnectedToReferenceModel) {
                                                        onSettingModelToBeMovedConnectedToReferenceModel(checked);
                                                    }
                                                }
                                            }
                                            checked={processStepItem.isModelToBeMovedConnectedToReferenceModel}
                                            title='Referenciamodell összekapcsolása az "Elem"-mel'
                                        />
                                        &nbsp;
                                        <QuestionCircleTwoTone
                                            title='Referenciamodell összekapcsolása az "Elem"-mel'
                                            style={{ fontSize: '15px', verticalAlign: 'middle' }}
                                        />
                                    </>
                                )
                                
                            }
                            <br />
                            {
                                processStepItem.referenceModelUUID ? (
                                    <>
                                        {
                                            processStepItem.referenceModelName && (
                                                <>
                                                    <img src={getImageUrl('check-icon.png')} alt='check-icon' style={{ width: '20px' }} />
                                                    &nbsp;
                                                    <span className='red-color fw-bold'>{ processStepItem.referenceModelName }</span>
                                                </>
                                            )
                                        }
                                    </>
                                ) : (
                                    <span className='red-color question-mark fw-bold'>?</span>
                                )
                            }
                        </div>
                        <div className='mb-1'>
                            <span
                                className='text-decoration-underline cursor-pointer'
                                onClick={() => setIsToolChooserModalOpen(true)}
                            >
                                Eszköz
                            </span>
                            <br />
                            {
                                processStepItem.tool ? (
                                    <>
                                        <div>
                                            <span
                                                className="cursor-pointer"
                                                style={{ color: 'red' }}
                                                onClick={
                                                    (e) => {
                                                        e.stopPropagation();
                                                        if (onToolDeleteClick) onToolDeleteClick();
                                                    }
                                                }
                                            >
                                                -&gt; eszköz törlése
                                            </span>
                                        </div>
                                        <div className="d-flex gap-2 align-items-center">
                                            <div>
                                                <img src={getImageUrl('check-icon.png')} alt='check-icon' style={{ width: '20px' }} />
                                            </div>
                                            <ModelViewer model={processStepItem.tool.model} />
                                            <div>
                                                { processStepItem.tool.name }
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <span className='red-color question-mark fw-bold'>?</span>
                                )
                            }
                        </div>
                        <div className='mb-1'>
                            <span
                                className={`text-decoration-underline cursor-pointer ${ processStepItem.endpointModelUUID && processStepItem.endpointModelUUID === selectedModelUUID && 'fw-bold' }`}
                                onClick={
                                    (e) => {
                                        e.stopPropagation();
                                        if (onEndpointModelClick) onEndpointModelClick();
                                    }
                                }
                            >
                                *Elem végpont
                                {
                                    processStepItem.hasTargetModel && processStepItem.endpointModelUUID && (
                                        <>
                                            &nbsp;
                                            <CloseOutlined
                                                style={{ color: 'red', fontSize: '18px', verticalAlign: 'sub' }}
                                                title="Elem végpont eltávolítása"
                                                onClick={
                                                    (e) => {
                                                        e.stopPropagation();
                                                        if (onEndpointModelDeleteClick) onEndpointModelDeleteClick();
                                                    }
                                                }
                                            />
                                        </>
                                    )
                                }
                            </span>
                            <br />
                            {
                                (processStepItem.hasTargetModel && processStepItem.endpointModelUUID) ? (
                                    <div className="d-flex gap-2 align-items-center">
                                        <div>
                                            <img src={getImageUrl('check-icon.png')} alt='check-icon' style={{ width: '20px' }} />
                                        </div>
                                        <div>
                                            Pozíció X:{processStepItem.targetXPosition} Y:{processStepItem.targetYPosition} Z:{processStepItem.targetZPosition}
                                            <br />
                                            Rotáció X:{THREE.MathUtils.radToDeg(processStepItem.targetXRotation)} Y:{THREE.MathUtils.radToDeg(processStepItem.targetYRotation)} Z:{THREE.MathUtils.radToDeg(processStepItem.targetZRotation)}
                                        </div>
                                    </div>
                                ) : (
                                    <span className='red-color question-mark fw-bold'>?</span>
                                )
                            }
                            
                        </div>
                        <div className="mt-2 text-center">
                            <Button
                                type="primary"
                                disabled={doneButtonDisabled}
                                icon={<CheckOutlined />}
                                onClick={handleDoneButtonClick}
                            >
                                Kész
                            </Button>
                        </div>
                    </AccordionBody>
                </AccordionItem>
            </Accordion>
            {
                isToolChooserModalOpen && (
                    <ToolChooserModal
                        isModalOpen={isToolChooserModalOpen}
                        onToggleModal={
                            (isOpen) => {
                                if (isOpen === undefined) setIsToolChooserModalOpen(!isToolChooserModalOpen);
                                else setIsToolChooserModalOpen(isOpen);
                            }
                        }
                        onChooseTool={handleToolChoose}
                        selectedToolId={processStepItem.tool?.id ?? null}
                    />
                )
            }
        </>
    );
};